import JobClient from './JobClient';
import HttpClient from '../../gateway/HttpClient';
import { BackgroundJob } from '../../domain/job/JobDomain';
import HttpMethod from '../../constant/HttpMethod';
import { JobMethods } from '../../constant/MethodNames';
import { AxiosRequestConfig } from 'axios';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import { notBlank, notUndefined } from '../../util/Assert';

class NestJobClient implements JobClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public schedule(job: BackgroundJob): Promise<void> {
    notUndefined(job, 'Job cannot be undefined');
    const payload = {
      job,
    };
    return this.httpClient.execute(HttpMethod.POST, JobMethods.SCHEDULE, payload);
  }

  public download(id: string): Promise<Blob | undefined> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    const req: AxiosRequestConfig = {
      url: JobMethods.DOWNLOAD + '/' + id,
      method: 'GET',
      responseType: 'blob',
    };
    return this.httpClient.executeWithRequest<{ data: Blob | undefined }>(req).then((r) => r?.data);
  }

  public count(query: Query): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.GET, JobMethods.COUNT, undefined, { query });
  }

  public findMany(query: Query): Promise<BackgroundJob[]> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.GET, JobMethods.FIND_MANY, undefined, { query });
  }

  public delete(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, JobMethods.DELETE + '/' + id);
  }
}

export default NestJobClient;
